import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [
  LIST_REQ_TECHS,
  LIST_REQ_TECHS_SUCCESS,
  LIST_REQ_TECHS_FAILURE,
] = createRequestActionTypes('chance/LIST_REQ_TECHS');

export const listReqTechs = createAction(
  LIST_REQ_TECHS,
  (searchData) => (searchData),
);
const listReqTechsSaga = createRequestSaga(
  LIST_REQ_TECHS,
  techApi.getReqTechs,
);

const UNLOAD_REQ_TECHS = 'chance/UNLOAD_REQ_TECHS';
export const unloadReqTechs = createAction(UNLOAD_REQ_TECHS);

export function* ReqTechsSaga() {
  yield takeLatest(LIST_REQ_TECHS, listReqTechsSaga);
}

const initialState = {
  techs: null,
  error: null,
};

const reqTechs = handleActions(
  {
    [LIST_REQ_TECHS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      techs: data.list.map((tech) => ({
        id: tech.workUuid,
        workUuid: tech.workUuid,
        prjUuid: tech.prjUuid,
        reqNo: tech.reqNo, //reqNo
        reqTitle: tech.reqTitle,
        reqTyp: tech.reqTyp,
        reqStrtDt: tech.reqStrtDt,
        reqEndDt: tech.reqEndDt,
        reqContext: tech.reqContext,
        reqUsr: tech.reqUsr,
        reqNm: tech.reqNm,
        plnTitle: tech.plnTitle,
        plnTyp: tech.plnTyp,
        plnStrtDt: tech.plnStrtDt,
        plnEndDt: tech.plnEndDt,
        plnContext: tech.plnContext,
        plnUsr: tech.plnUsr,
        plnNm: tech.plnNm,
        workStatus:tech.workStatus,
        workGrade:tech.workGrade,
        rsltUuid:tech.rsltUuid,
        useYn:tech.useYn,
        crtNm:tech.crtNm,
        crtDt:tech.crtDt,
        cngNm:tech.cngNm,
        cngDt:tech.cngDt,
      })),
      error: null,
    }),
    [LIST_REQ_TECHS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_REQ_TECHS]: () => initialState,
  },
  initialState,
);

export default reqTechs;
